import { memo, Suspense } from 'react';

import { connect } from 'react-redux';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import { Container } from 'src/components/Container';
import { BreadcrumbsItem } from 'src/containers/Breadcrumbs';

import { AppState } from 'src/store';
import { sessionSelectors } from 'src/store/session/selectors';
import { VaultOverview } from './VaultOverview';
import { FormattedMessage } from 'react-intl';

export const _VaultRoutes = () => {
  const match = useRouteMatch();

  return (
    <Container pb="4xl">
      <Suspense fallback={null}>
        <BreadcrumbsItem
          label={<FormattedMessage defaultMessage="Archived backups" id="backups.vault.archived_backups_name" />}
          url={match.url}
        />

        <Switch>
          <Route exact path={match.path} component={VaultOverview} />
        </Switch>
      </Suspense>
    </Container>
  );
};

const stateToProps = (state: AppState) => ({
  member: sessionSelectors.getMember(state),
});

export default connect(stateToProps)(memo(_VaultRoutes));
